import axiosInterceptor from "../../utils/axiosInterseptor";

export const createPostRoute = (data) =>
  axiosInterceptor.post("/admin/createAdminPost", data);
export const getAdminPostsRoute = () =>
  axiosInterceptor.get("/admin/getAdminPosts");
export const deleteAdminPostsRoute = (post_id) =>
  axiosInterceptor.delete(`/admin/deleteShot/?post_id=${post_id}`);
